var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-text",style:(_vm.componentStyles)},[_c('div',{staticClass:"inner",domProps:{"innerHTML":_vm._s(_vm.data.text)}},[_vm._v("\n        RichText\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }